export const TEXTS = {
  SUBMIT_BUTTON_DEFAULT_TEXT: 'Отправить',
  CANCEL_BUTTON_DEFAULT_TEXT: 'Отменить',
  TEXT_FIELD_INVALID_TEXT: 'Проверьте введенные данные',
};
